import React, { useState } from 'react';
import Loader from 'saur_ui_library/src/Atoms/Loader/Loader';
import DownloadIcon from 'saur_ui_library/src/Icons/DownloadIcon';
import {
  defineExtendedUrl,
  hydroDataFormated,
  prepareDataToSend,
  requestToGetCsv,
} from '../../../utils/helpers/table/exportTableHelper';

const ExportTable = ({ data, type, contractLabel }) => {
  const [warning, setWarning] = useState('');
  const [loader, setLoader] = useState(false);

  // method to export content of table
  const launchExportTable = () => {
    let dataParam;
    setWarning('');
    setLoader(true);
    if (type === 'hydro') {
      dataParam = prepareDataToSend(hydroDataFormated(data), type);
    } else {
      dataParam = prepareDataToSend(data, type);
    }
    const body = JSON.stringify(dataParam);
    const extendedUrl = defineExtendedUrl(type);

    requestToGetCsv(body, type, contractLabel, extendedUrl)
      .then(() => {
        setLoader(false);
        if (warning !== '') {
          setWarning('');
        }
      })
      .catch(() => {
        setLoader(false);
        setWarning('Impossible de récupérer le fichier');
      });
  };

  return (
    <>
      <div style={{ display: 'inline-flex', alignSelf: 'end' }}>
        <span style={{ color: 'red', fontSize: 'smaller', padding: '3px' }}>
          {warning}
        </span>
        {loader ? (
          <div style={{ transform: 'scale(0.5)', height: '5px' }}>
            <Loader />
          </div>
        ) : (
          <button
            title='Export'
            onClick={launchExportTable}
            style={{ width: 'fit-content', alignSelf: 'end' }}
          >
            <DownloadIcon />
          </button>
        )}
      </div>
    </>
  );
};

export default ExportTable;
